import styled from 'styled-components';

export const OptionsSelectorWrapper = styled.div`
  background-color: white;
  border: 1px solid black;
  border-radius: 3px;
  padding: 1rem;
`;
